import {
  DatasetSessionCompareDefaultsProps,
  METRICS_COLUMNS,
  TextDisplayMode,
} from '@/Pages/DatasetSessionCompare/constants';
import { useComparisonViewDisplaySettings } from '@/Pages/DatasetSessionCompare/utils/useComparisonViewDisplaySettings';

import { PromptOutputSectionHeader } from '../Playground/PlaygroundHome/PromptOutputSectionHeader';
import { usePlaygroundStore } from '../Playground/PlaygroundHome/hooks/usePlaygroundStore';
import { EvaluatorPlaygroundExperimentView } from './EvaluatorPlaygroundExperimentView';
import { useSortedPlaygroundExampleRuns } from './hooks/useSortedPlaygroundExampleRuns';

const DEFAULT_DISPLAY_SETTINGS: DatasetSessionCompareDefaultsProps = {
  textDisplayMode: TextDisplayMode.FULL,
  hideMetrics: true,
  hiddenMetricsColumns: Object.values(METRICS_COLUMNS).map((c) => c.name),
  hideFeedback: false,
  isReferenceInputHidden: false,
  isReferenceOutputHidden: false,
  language: 'json' as const,
};

export function EvaluatorPromptOutputSection() {
  const datasetId = usePlaygroundStore((state) => state.datasetId);
  const inputSourceType = usePlaygroundStore((state) => state.inputSourceType);
  const evaluatorFeedbackKeys = usePlaygroundStore(
    (state) => state.evaluatorFeedbackKeys
  );

  const displaySettingsState = useComparisonViewDisplaySettings({
    aggregateFeedbackKeys: evaluatorFeedbackKeys,
    localStorageStatePrefix: 'align_playground_display_settings',
    defaultSettings: DEFAULT_DISPLAY_SETTINGS,
  });

  const isCreatingNewDataset = usePlaygroundStore(
    (state) => state.isCreatingNewDataset
  );

  const sessionId = usePlaygroundStore((state) => state.prompts[0]?.sessionId);

  const { exampleRuns, shouldHighlightExamples } =
    useSortedPlaygroundExampleRuns({
      sessionId,
    });

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <PromptOutputSectionHeader
        displaySettingsState={displaySettingsState}
        exampleRuns={exampleRuns}
        isEditable={false}
      />
      <div className="flex-grow overflow-auto">
        {inputSourceType === 'dataset' &&
        !(datasetId || isCreatingNewDataset) ? (
          <div className="m-8 text-center text-secondary">
            No dataset selected
          </div>
        ) : (
          <EvaluatorPlaygroundExperimentView
            datasetId={datasetId}
            displaySettingsState={displaySettingsState}
            exampleRuns={exampleRuns.slice(0, 100)}
            shouldHighlightExamples={shouldHighlightExamples}
          />
        )}
      </div>
    </div>
  );
}
